module.exports = "/packs/banner_pc_popular-8d64ad0e928539dba57b8f4b1e1ae6be.png";